"use client";

import { ArrowRight, CheckCircle2 } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const PASSPORT_IMAGE = "https://ideal-jay.10web.cloud/wp-content/uploads/2026/07/home_passport.png";
const LAUNCH_NOW_ICON = "https://ideal-jay.10web.cloud/wp-content/uploads/2026/07/teelistclub-launch-now.svg";
const COMING_NEXT_ICON = "https://ideal-jay.10web.cloud/wp-content/uploads/2026/07/teelistclub-coming-next.svg";
const launchNow = ["Save favourite courses", "Build trip shortlists", "Follow destinations", "Join early access"];
const comingNext = ["Track played courses", "Smarter recommendations", "Course Match integration", "Member benefits when ready"];
export default function Golfpassportmembership() {
  return <section id="home-golf-passport" data-section-id="3069" data-home-section="golf-passport" aria-label="TeeListClub Golf Passport" className="w-full bg-[#F7F3E9] px-5 pb-16 pt-0 !h-auto lg:!min-h-[650px] md:px-8 md:pb-20 lg:px-12 lg:pb-24" style={{
    fontFamily: '"Raleway", Arial, sans-serif'
  }}>
      <div className="mx-auto w-full max-w-[1480px]">
        <div className={["grid w-full grid-cols-1", "overflow-hidden rounded-[18px]", "border border-[#DED3B9]", "bg-[#FFFDF7]", "shadow-[0_10px_28px_rgba(7,63,49,0.06)]", "lg:grid-cols-[38%_62%]"].join(" ")}>
          {/* Passport visual */}
          <div className={["relative min-h-[360px]", "overflow-hidden", "border-b border-[#DED3B9]", "bg-[#073F31]", "lg:min-h-[570px]", "lg:border-b-0 lg:border-r"].join(" ")}>
            <img src={PASSPORT_IMAGE} alt="TeeListClub Golf Passport" loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover object-center !bg-[rgba(0,0,0,0.5)]" />

            <div aria-hidden="true" className={["pointer-events-none absolute inset-0", "bg-[linear-gradient(90deg,rgba(3,39,31,0.02)_0%,rgba(3,39,31,0)_72%,rgba(3,39,31,0.10)_100%)]"].join(" ")} />
          </div>

          {/* Passport content */}
          <div className={["flex min-w-0 flex-col", "px-7 py-10", "sm:px-9 sm:py-11", "lg:px-12 lg:py-12", "xl:px-14 xl:py-14"].join(" ")}>
            <p className="text-[10px] font-extrabold uppercase tracking-[0.21em] text-[#9A793A]">
              Golf Passport
            </p>

            <h2 className={["mt-3 max-w-[820px]", "text-[38px] font-medium", "leading-[1.03]", "tracking-[-0.035em]", "text-[#073F31]", "sm:text-[43px]", "lg:text-[48px]", "xl:text-[52px]"].join(" ")} style={{
            fontFamily: '"Playfair Display", Georgia, "Times New Roman", serif'
          }}>
              Start now. More to come.
            </h2>

            <p className="mt-3 text-[14px] font-semibold leading-[1.55] text-[#52675F] sm:text-[15px]">
              Save courses. Follow destinations. Build your Golf Passport.
            </p>

            <div className="mt-4 h-[2px] w-[42px] bg-[#B79A5F]" />

            <p className={["mt-4 max-w-[850px]", "text-[13px] font-medium", "leading-[1.6]", "text-[#596B63]", "sm:text-[14px]"].join(" ")}>
              Golf Passport launches as TeeListClub’s free golfer account — a
              simple way to save courses, build trip shortlists and receive
              more relevant updates as TeeListClub grows.
            </p>

            {/* Feature columns */}
            <div className={["mt-7 grid grid-cols-1", "gap-8", "sm:grid-cols-2 sm:gap-0"].join(" ")}>
              {/* Launch now */}
              <div className="sm:border-r sm:border-[#D4CCBA] sm:pr-8">
                <div className="flex items-center gap-4">
                  <img src={LAUNCH_NOW_ICON} alt="" aria-hidden="true" loading="lazy" className="size-[48px] shrink-0" />

                  <div>
                    <p className="text-[9px] font-extrabold uppercase tracking-[0.17em] text-[#789134]">
                      Available
                    </p>

                    <h3 className="mt-1 text-[20px] font-semibold leading-none text-[#073F31]" style={{
                    fontFamily: '"Playfair Display", Georgia, "Times New Roman", serif'
                  }}>
                      Launch now
                    </h3>
                  </div>
                </div>

                <ul className="mt-5 space-y-2.5">
                  {launchNow.map(item => <li key={item} className="flex items-center gap-2.5 text-[13px] font-semibold leading-[1.45] text-[#52675F]">
                      <CheckCircle2 className="size-[16px] shrink-0 text-[#91AF24]" strokeWidth={1.8} aria-hidden="true" />

                      <span>{item}</span>
                    </li>)}
                </ul>
              </div>

              {/* Coming next */}
              <div className="sm:pl-8">
                <div className="flex items-center gap-4">
                  <img src={COMING_NEXT_ICON} alt="" aria-hidden="true" loading="lazy" className="size-[48px] shrink-0" />

                  <div>
                    <p className="text-[9px] font-extrabold uppercase tracking-[0.17em] text-[#9A8356]">
                      In development
                    </p>

                    <h3 className="mt-1 text-[20px] font-semibold leading-none text-[#073F31]" style={{
                    fontFamily: '"Playfair Display", Georgia, "Times New Roman", serif'
                  }}>
                      Coming next
                    </h3>
                  </div>
                </div>

                <ul className="mt-5 space-y-2.5">
                  {comingNext.map(item => <li key={item} className="flex items-center gap-2.5 text-[13px] font-semibold leading-[1.45] text-[#52675F]">
                      <CheckCircle2 className="size-[16px] shrink-0 text-[#91AF24]" strokeWidth={1.8} aria-hidden="true" />

                      <span>{item}</span>
                    </li>)}
                </ul>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-8 flex flex-wrap items-center gap-4">
              <Button asChild className={["h-[50px] rounded-[8px]", "bg-[#BFFF00] px-6", "text-[11px] font-bold uppercase", "tracking-[0.055em]", "text-[#073F31]", "shadow-none", "hover:bg-[#CBFF36]"].join(" ")}>
                <Link href="/my-golf-passport/" className="inline-flex items-center gap-5">
                  Create My Golf Passport

                  <ArrowRight className="size-[17px]" strokeWidth={1.8} aria-hidden="true" />
                </Link>
              </Button>

              <span className={["inline-flex items-center", "rounded-full", "border border-[#D8C69B]", "bg-[#F7F3E9]", "px-4 py-2", "text-[12px] font-extrabold", "tracking-[0.01em]", "text-[#29483E]"].join(" ")}>
                Free to join
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}